import api from './api';

const API_URL = '/event-categories';

export interface EventCategory {
  _id: string;
  name: string;
  description?: string;
  color?: string;
  schoolId: string;
  isActive: boolean;
}

export interface CreateEventCategoryData {
  name: string;
  description?: string;
  color?: string;
}

const getCategories = async (search?: string): Promise<EventCategory[]> => {
  const params: any = {};
  if (search) params.search = search;

  const response = await api.get(API_URL, { params });
  return response.data.data.categories;
};

const createCategory = async (data: CreateEventCategoryData): Promise<EventCategory> => {
  const response = await api.post(API_URL, data);
  return response.data.data;
};

const updateCategory = async (id: string, data: Partial<CreateEventCategoryData>): Promise<EventCategory> => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data.data;
};

const deleteCategory = async (id: string): Promise<void> => {
  await api.delete(`${API_URL}/${id}`);
};

const eventCategoryService = {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory
};

export default eventCategoryService;
